/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { MoveActor } from '../../actors/MoveActor';
import { SequenceActor } from '../../actors/SequenceActor';
import { ObjectManipulator } from '../../utils/ObjectManipulator';
import { CapNames } from '../CapNames';
/**
 * Capability to set or animate Object3D (or shader uniforms) attributes
 */
export class ActorCap {
    /**
     * see base class
     */
    getName() {
        return CapNames.ACTOR;
    }
    /**
     * see base class
     */
    call(objectIn, sceneIn) {
        const payload = objectIn.payload;
        if (!!payload && !!payload.act) {
            switch (payload.act) {
                case 'set':
                    if (payload.objectId != null) {
                        const obj = sceneIn.getObjectById(payload.objectId);
                        ObjectManipulator.setAttributeList(obj, payload.action.target);
                    }
                    break;
                case 'sequence':
                    const actorSeq = new SequenceActor(sceneIn, payload);
                    sceneIn.getStage().addActor(actorSeq);
                    actorSeq.start();
                    break;
                case 'move':
                    const actorMove = MoveActor.createFromDescription(sceneIn, payload);
                    sceneIn.getStage().addActor(actorMove);
                    actorMove.start();
                    break;
                default:
                    break;
            }
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=ActorCap.js.map